$eve_chip $eve_flex
	direction \row
	align_items \center
	justify_content \flex-start
	colors? \low
	variant? \soft
	size? \s
	attr *
		^
		role \group
	sub /
		<= Label $eve_text
			variant \text
			colors? null
			text_variant \bodyMd
			content <= label \
		<= Remove $eve_button
			variant \ghost
			colors? \lowest
			size? \xs
			hint <= remove_hint \Remove
			click?event <=> remove_click?event null
			sub /
				<= Remove_icon $mol_icon_close
